import { render } from "./IconQuestionMarkSm.vue?vue&type=template&id=0e82d560"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__